import { render, staticRenderFns } from "./CustomerCustomHistoryField.vue?vue&type=template&id=195efaf6"
import script from "./CustomerCustomHistoryField.vue?vue&type=script&lang=js"
export * from "./CustomerCustomHistoryField.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomHistoryField.vue?vue&type=style&index=0&id=195efaf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports